import React, { useContext } from "react";
import star_icon from "../Assets/star_icon.png";
import star_dull_icon from "../Assets/star_dull_icon.png";
import { ShopContext } from "../../Context/ShopContext";
import { backend_url, currency } from "../../App";

const ProductDisplay = ({product}) => {

  const {addToCart} = useContext(ShopContext);
  const imgSrc = String(product.image).startsWith('http') ? product.image : backend_url + product.image;

  return (
    <div className="flex px-[10%] py-10 gap-10 max-[800px]:flex-wrap max-[1024px]:px-[6%]">
      {/* Image gallery */}
      <div className="flex gap-[18px] max-[900px]:gap-2.5 max-[800px]:w-full max-[800px]:justify-center">
        <div className="flex flex-col gap-3 max-[1024px]:gap-2.5">
          {[0,1,2,3].map(i => (
            <img key={i} src={imgSrc} alt="img" className="h-[110px] w-[90px] object-cover rounded-xl border border-white/[0.08] cursor-pointer bg-white/[0.03] hover:border-[rgba(0,212,255,0.5)] transition-colors max-[1024px]:h-[90px] max-[900px]:h-[80px] max-[500px]:h-[68px] max-[500px]:w-[60px]" />
          ))}
        </div>
        <div>
          <img className="h-[500px] w-auto object-cover rounded-2xl border border-white/[0.08] bg-white/[0.03] max-[1024px]:h-[400px] max-[900px]:h-[350px] max-[500px]:h-[300px]" src={imgSrc} alt="img" />
        </div>
      </div>

      {/* Product info */}
      <div className="flex flex-col flex-1">
        <h1 className="text-white text-3xl font-bold leading-tight max-[500px]:text-xl">{product.name}</h1>

        {/* Stars */}
        <div className="flex items-center mt-3 gap-1.5 text-[#a0aec0] text-sm">
          <img src={star_icon} alt="" className="w-4" />
          <img src={star_icon} alt="" className="w-4" />
          <img src={star_icon} alt="" className="w-4" />
          <img src={star_icon} alt="" className="w-4" />
          <img src={star_dull_icon} alt="" className="w-4" />
          <p className="text-[#6b7a8d] ml-1">(122)</p>
        </div>

        {/* Price */}
        <div className="flex items-center my-6 gap-4 max-[500px]:mt-4">
          <span className="text-[#4a5568] text-xl font-semibold line-through">{currency}{product.old_price}</span>
          <span className="text-[#00d4ff] text-3xl font-black max-[500px]:text-xl">{currency}{product.new_price}</span>
          {product.old_price > product.new_price && (
            <span className="bg-gradient-to-br from-[#00d4ff] to-[#7c3aed] text-white text-xs font-extrabold px-2.5 py-1 rounded-full">
              -{Math.round(((product.old_price - product.new_price) / product.old_price) * 100)}% OFF
            </span>
          )}
        </div>

        {/* Description */}
        <div className="text-[#a0aec0] text-sm leading-relaxed border-t border-white/[0.06] pt-5">{product.description}</div>

        {/* Size selector */}
        <div className="mt-7">
          <h3 className="text-[#c0c8d8] text-base font-semibold mb-4">Select Size</h3>
          <div className="flex gap-3 flex-wrap mb-6">
            {['S', 'M', 'L', 'XL', 'XXL'].map(size => (
              <div key={size} className="px-5 py-3 bg-white/[0.04] border border-white/[0.1] rounded-xl text-[#a0aec0] text-sm font-semibold cursor-pointer hover:border-[rgba(0,212,255,0.5)] hover:text-[#00d4ff] hover:bg-[rgba(0,212,255,0.08)] transition-all">
                {size}
              </div>
            ))}
          </div>
        </div>

        {/* Add to Cart */}
        <button
          onClick={() => addToCart(product.id)}
          className="flex items-center gap-2.5 px-10 py-4 w-fit rounded-xl border-none text-[#060c18] text-base font-extrabold cursor-pointer mb-6 transition-all hover:-translate-y-0.5 hover:shadow-[0_0_40px_rgba(0,212,255,0.5)] font-[inherit]"
          style={{ background: 'linear-gradient(135deg, #00d4ff, #0077aa)', boxShadow: '0 0 24px rgba(0,212,255,0.3)' }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
          </svg>
          ADD TO CART
        </button>

        {/* Meta */}
        <div className="flex flex-col gap-2 pt-4 border-t border-white/[0.06] text-sm text-[#a0aec0]">
          <p><span className="text-[#c0c8d8] font-semibold">Category : </span>{product.category}</p>
          <p><span className="text-[#c0c8d8] font-semibold">Tags : </span>Modern, Latest</p>
        </div>

        {/* Return Policy */}
        <div className="mt-5 p-4 rounded-xl border border-[rgba(0,212,255,0.15)] bg-[rgba(0,212,255,0.04)]">
          <p className="text-[#00d4ff] font-bold text-sm mb-2 flex items-center gap-2">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
              <polyline points="1 4 1 10 7 10"/>
              <path d="M3.51 15a9 9 0 1 0 .49-3.32"/>
            </svg>
            7-Day Return Policy
          </p>
          <ul className="text-[#a0aec0] text-xs leading-relaxed space-y-1">
            <li>✔ Request a return within 7 days of delivery</li>
            <li>✔ Item must be unused and in original packaging</li>
            <li>✔ Refund processed within 3–5 business days after approval</li>
            <li>✔ Free return pickup for eligible orders</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProductDisplay;
